// Small pure numeric helpers shared across the visuals layer. No PixiJS / browser API.

export function clamp(x: number, lo: number, hi: number): number {
  return x < lo ? lo : x > hi ? hi : x;
}

/** Standard GLSL-style smoothstep. Returns 0 below lo, 1 above hi, smooth Hermite between. */
export function smoothstep(lo: number, hi: number, x: number): number {
  if (lo === hi) return x < lo ? 0 : 1;
  const t = clamp((x - lo) / (hi - lo), 0, 1);
  return t * t * (3 - 2 * t);
}
